module.exports = ".containerSelect {\n  position: relative;\n}\n\nspinner-component {\n  position: absolute;\n  top: -5px;\n  right: 12px;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/shared/components/autocomplete-insert/autocomplete-insert.component.css
 ** module id = 121
 ** module chunks = 0
 **/